import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { CallbackModal } from '../../components/CallbackDesktopWidget/CallbackModal';
import { WidgetLoader } from '../../components/CallbackDesktopWidget/WidgetLoader';
import { WorkTimeFailure } from '../../components/CallbackDesktopWidget/WorkTimeFailure';
import { useWorkTime } from '../../hooks/useWorkTime';
import { ERequestStatus } from '../../types/request';
import { ThemeContext } from '../../utils/themeContext';
import { CallbackContentContainer } from './parts/CallbackContent';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var CallbackWidget = function CallbackWidget(props) {
  var open = props.open,
    onClose = props.onClose,
    onRequestWorkTime = props.onRequestWorkTime,
    theme = props.theme,
    _props$callbackButton = props.callbackButtonText,
    callbackButtonText = _props$callbackButton === void 0 ? 'Перезвоните мне' : _props$callbackButton;
  var _useWorkTime = useWorkTime({
      onRequestWorkTime: onRequestWorkTime,
      open: open
    }),
    workTime = _useWorkTime.workTime,
    status = _useWorkTime.status,
    requestWorkTime = _useWorkTime.requestWorkTime;
  return /*#__PURE__*/_jsx(ThemeContext.Provider, {
    value: theme,
    children: /*#__PURE__*/_jsxs(CallbackModal, {
      open: open,
      onClose: onClose,
      children: [status === ERequestStatus.Loading && /*#__PURE__*/_jsx(WidgetLoader, {}), status === ERequestStatus.Failure && /*#__PURE__*/_jsx(WorkTimeFailure, {
        onConfirm: requestWorkTime
      }), status === ERequestStatus.Success && /*#__PURE__*/_jsx(CallbackContentContainer, _objectSpread(_objectSpread({}, props), {}, {
        workTime: workTime,
        callbackButtonText: callbackButtonText
      }))]
    })
  });
};